import { getDomain } from './domainMapping';

export interface CompanyMoneyFormat {
  decimalSeparator: string;
  numberOfDecimals: number;
  currency: string;
}

export interface CompanyMoneyFormatWithSymbol extends CompanyMoneyFormat {
  currencySymbol: string;
}

function getCurrencyFormatter(
  amount: number,
  currencyCode: string,
  numberOfDecimals: number
): string {
  const fullLocale = getDomain.getCurrentDomainSpec().FullLocale;

  if (amount % 1 === 0) {
    return new Intl.NumberFormat(fullLocale, {
      style: 'currency',
      currency: currencyCode,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(amount);
  }

  return new Intl.NumberFormat(fullLocale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: numberOfDecimals,
  }).format(amount);
}

function getNumberFormatter(amount: number, numberOfDecimals: number): string {
  const fullLocale = getDomain.getCurrentDomainSpec().FullLocale;

  if (amount % 1 === 0) {
    return new Intl.NumberFormat(fullLocale, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(amount);
  }

  return new Intl.NumberFormat(fullLocale, {
    minimumFractionDigits: numberOfDecimals,
  }).format(amount);
}

export function formatWithCurrency(amount: number, currency?: string): string {
  const curentCurrency =
    currency !== undefined && currency !== ''
      ? currency
      : getDomain.getCurrentDomainSpec().MoneyFormat.currency;
  return getCurrencyFormatter(
    amount,
    curentCurrency,
    getDomain.getCurrentDomainSpec().MoneyFormat.numberOfDecimals
  );
}

export function formatWithoutCurrencySymbol(amount: number): string {
  return getNumberFormatter(
    amount,
    getDomain.getCurrentDomainSpec().MoneyFormat.numberOfDecimals
  );
}
